
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  email: null,
  firstName: null,
  lastName: null,
  userID: null,
  role: 'user', 
  allUsers: [],
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    SET_ACTIVE_USER: (state, action) => {
      const { email, firstName, lastName, userID, role } = action.payload; 
      state.isLoggedIn = true;
      state.email = email;
      state.firstName = firstName;
      state.lastName = lastName;
      state.userID = userID;
      state.role = role || 'user'; 
    },
    REMOVE_ACTIVE_USER(state, action) {
      state.isLoggedIn = false;
      state.email = null;
      state.firstName = null;
      state.lastName = null;
      state.userID = null;
      state.role = 'user'; 
      state.allUsers = [];
    },
    SET_ALL_USERS: (state, action) => {
      state.allUsers = action.payload;
    },
  },
});

export const { SET_ACTIVE_USER, REMOVE_ACTIVE_USER, SET_ALL_USERS } = authSlice.actions;

export const selectIsLoggedIn = (state) => state.auth.isLoggedIn;
export const selectEmail = (state) => state.auth.email;
export const selectFirstName = (state) => state.auth.firstName;
export const selectLastName = (state) => state.auth.lastName;
export const selectUserID = (state) => state.auth.userID;
export const selectRole = (state) => state.auth.role; 
export const selectIsAdmin = (state) => state.auth.role === 'admin'; 
export const selectAllUsers = (state) => state.auth.allUsers;

export default authSlice.reducer;
